import breakpoints from 'base/constants/breakpoints';
import styled from 'styled-components';

interface TabsContainerProps {
  isTabsSticky?: boolean;
  isMobile?: boolean;
}

export const TabsContainer = styled.div<TabsContainerProps>`
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  padding: 16px 64px;
  column-gap: 40px;
  position: sticky;
  z-index: 1000;
  margin-top: -10px;
  top: var(--tabs-top, 124px);
  overflow-x: auto;
  overflow-y: hidden;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media screen and ${breakpoints.maxWidth.md} {
    padding: 8px;
    box-shadow: 0px;
    column-gap: 12px;
  }
`;

export const Tab = styled.div`
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  letter-spacing: -0.12px;

  @media screen and ${breakpoints.maxWidth.md} {
    font-size: 14px;
    padding: 8px;
    color: #0071cd;
    font-weight: 400;
    padding: 12px;
    border: 1px solid #c6e6ff;
    border-radius: 8px;
  }

  &.selected {
    color: #0071cd;
    font-weight: 600;
    @media screen and ${breakpoints.maxWidth.md} {
      border: 2px solid #0071cd;
      box-shadow: 0 0 0 3px rgba(0, 146, 228, 0.25);
      background: #eaf6ff;
    }
  }
  &.selected::after {
    content: ' ';
    border-bottom: 3px solid #0071cd;
    position: relative;
    top: 16px;
    display: block;
    @media screen and ${breakpoints.maxWidth.md} {
      top: 12px;
      border-bottom: none;
    }
  }
`;
